export function formatDate(inputDate: string, displayTime: boolean = true, displaySeconds: boolean = false): string {
  // sample output Feb 28,2024.
  if (!inputDate) return ''

  const isYearMonthFormat = /^\d{4}-\d{2}$/.test(inputDate) // This is for returning Year month for Yearly grpahs. Otherwise by default 01 is added as date
  const isYearMonthDayFormat = /^\d{4}-\d{2}-\d{2}$/.test(inputDate)

  let date: Date

  if (isYearMonthFormat) {
    const [y, m] = inputDate.split('-').map(Number)
    date = new Date(y, m - 1, 1)
  } else if (isYearMonthDayFormat) {
    // Avoid UTC parsing quirks of "YYYY-MM-DD" by constructing in local time
    const [y, m, d] = inputDate.split('-').map(Number)
    date = new Date(y, m - 1, d)
  } else {
    date = new Date(inputDate)
  }

  if (Number.isNaN(date.getTime())) return ''

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const year = date.getFullYear()
  const month = months[date.getMonth()]
  const day = String(date.getDate()).padStart(2, '0')

  let result = isYearMonthFormat ? `${month}, ${year}` : `${month} ${day}, ${year}`

  if (displayTime) {
    const hh = String(date.getHours()).padStart(2, '0')
    const mm = String(date.getMinutes()).padStart(2, '0')
    result += ` ${hh}:${mm}`

    if (displaySeconds) {
      const ss = String(date.getSeconds()).padStart(2, '0')
      result += `:${ss}`
    }
  }

  return result
}

export function parseTime(seconds: number) {
  let totalMinutes = Math.round(seconds / 60)

  let hours = Math.floor(totalMinutes / 60)
  let minutes = totalMinutes % 60

  // let remainingSeconds = seconds % 60;

  let timeString = ''

  if (hours > 0) {
    timeString += hours + ' Hour'
    if (hours > 1) timeString += 's'
    timeString += ' '
  }

  if (minutes > 0) {
    timeString += minutes + ' Minute'
    if (minutes > 1) timeString += 's'
    timeString += ' '
  }

  // if (remainingSeconds > 0 || timeString === '') {
  //     timeString += remainingSeconds + ' Second';
  //     if (remainingSeconds !== 1) timeString += 's';
  // }

  return timeString.trim()
}

// below function will give week range for the input date e.g. Dec 24-30, 2023. (input date always has to be last sunday of the week)
export function formatWeekDate(inputDate: string) {
  let endOfWeek

  if (typeof inputDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
    const [y, m, d] = inputDate.split('-').map(Number)
    endOfWeek = new Date(y, m - 1, d) // prevents UTC-5 shifting to Saturday
  } else {
    endOfWeek = new Date(inputDate)
  }

  if (Number.isNaN(endOfWeek.getTime())) return ''

  const startOfWeek = new Date(endOfWeek)
  startOfWeek.setDate(endOfWeek.getDate() - 6) // start of the week is 6 days earlier than end of the week

  const currentDate = new Date()
  const startOfMonth = startOfWeek.getMonth()
  const endOfMonth = endOfWeek.getMonth()

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const isToday = currentDate.getFullYear() === endOfWeek.getFullYear() && currentDate.getMonth() === endOfWeek.getMonth() && currentDate.getDate() === endOfWeek.getDate()

  if (startOfMonth === endOfMonth) {
    return `${months[startOfMonth]} ${startOfWeek.getDate()} - ${isToday ? currentDate.getDate() : endOfWeek.getDate()}, ${startOfWeek.getFullYear()}`
  } else {
    return `${months[startOfMonth]} ${startOfWeek.getDate()} - ${months[endOfMonth]} ${endOfWeek.getDate()}, ${startOfWeek.getFullYear()}`
  }
}
